import { Alert, Button, Card, Center, Code, Group, Stack, Text } from "@mantine/core";
import { useRouteError } from "react-router";

/**
 * 路由级错误边界。挂在各路由的 ErrorBoundary 上，渲染异常时显示友好页面，
 * 取代 react-router 默认的「Unexpected Application Error」白屏。
 */
export function RouteError() {
  const error = useRouteError();
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "未知错误";
  const stack = error instanceof Error ? error.stack : null;

  return (
    <Center style={{ minHeight: "60vh" }} p="md">
      <Card
        shadow="sm"
        padding="lg"
        radius="md"
        withBorder
        style={{ width: 560, maxWidth: "100%" }}
      >
        <Stack gap="md">
          <Text fw={600} size="lg">
            页面出错了
          </Text>
          <Alert color="red" title="错误信息">
            <Code block>{message}</Code>
          </Alert>
          {stack !== null && stack !== undefined ? (
            <Code block style={{ maxHeight: 180, overflow: "auto", fontSize: 11 }}>
              {stack}
            </Code>
          ) : null}
          <Text size="sm" c="dimmed">
            页面渲染时发生异常。可尝试刷新，或返回首页；若反复出现请联系开发并附上以上错误信息。
          </Text>
          <Group justify="flex-end">
            <Button variant="default" onClick={() => window.location.assign("/")}>
              返回首页
            </Button>
            <Button onClick={() => window.location.reload()}>刷新页面</Button>
          </Group>
        </Stack>
      </Card>
    </Center>
  );
}
